import * as React from 'react'

import { useModal } from '@procurify/ui'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryCardPin } from '../../models/useQueryCardPin'
import { CardPinModal } from '../../views/CardPinModal'

export const usePhysicalCardPinPresenter = ({
  externalId,
  scaToken,
  onVerificationRequired,
}: {
  externalId: string
  scaToken?: string
  onVerificationRequired?: (scaSessionCode: string) => void
}) => {
  const intl = useProcurifyIntl()
  const modal = useModal()

  const [showPin, setShowPin] = React.useState(false)

  const { iframeUrl, isFetching, refetch, clearIframeUrl } = useQueryCardPin({
    externalId,
    scaToken,
    customCss,
    onVerificationRequired,
    enabled: showPin,
    onError: () =>
      toast.error({
        title: intl.formatMessage(messages.fetchingPinErrorToast),
      }),
  })

  const openCardPinModal = (url: string) => {
    modal.showModal(CardPinModal, {
      open: true,
      onClose: () => {
        modal.hideModal()
        setShowPin(false)
        clearIframeUrl()
      },
      iframeUrl: url,
    })
  }

  React.useEffect(() => {
    if (iframeUrl) {
      openCardPinModal(iframeUrl)
    }
  }, [iframeUrl])

  return {
    commands: {
      openCardPinModal: () => {
        if (showPin) {
          refetch()
        } else {
          setShowPin(true)
        }
      },
    },
    states: {
      showLoader: isFetching,
    },
  }
}

const customCss = {
  '.pin': {
    fontSize: '20px',
    fontFamily: 'Arial',
    textAlign: 'center',
    fontWeight: 'bold',
  },
}
